export default {
  carta: "LETTRE",
  yourLastOrders: "VOS DERNIÈRES COMMANDES",
  productOrderNotAvailable:
    "Désolé, le produit que vous commandez n'est pas disponible.",
  noOrders: "Vous n'avez pas encore de commandes",
  updated: "Actualisé!",
  updatingzClosuresSummaryCollection:
    "Mise à jour de la collection récapitulative de zClosures...",
  updateOrdersAndPaymentSummariesCollection:
    "Mise à jour de la collecte des bons de commande et des récapitulatifs de paiement...",
  whatDishesAre: "Quels sont les plats",
  theMaximumNumberOfProductAllowed:
    "Le nombre maximum de produits autorisés est de 20",
  orderPlaced: "Commande passée",
  updatePaymentsCollection: "Mise à jour de l'encaissement des paiements ..."
};
